/* Clarity-only custom events: no GA pageviews or purchases. */
(() => {
  if (window.ppNavigationAnalyticsInstalled) return;
  window.ppNavigationAnalyticsInstalled = true;
  const preview = document.querySelector('[data-pp-tracking-preview]') !== null;
  const log = [];
  const slug = s => typeof s === 'string' && /^[a-z0-9][a-z0-9_-]{0,99}$/.test(s);
  const allowed = () => { try { return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true; } catch { return false; } };
  const path = href => {
    try {
      const u = new URL(href, window.location.origin);
      if (u.origin !== window.location.origin || u.username || u.password) return null;
      const p = u.pathname.replace(/\/$/, '') || '/';
      if (p === '/') return {name:'home',type:'home',tags:''};
      const m = p.match(/^\/(collections|pages)\/([a-z0-9][a-z0-9_-]{0,99})(?:\/([a-z0-9_+%-]+))?$/);
      if (!m || ['vendors','types'].includes(m[2]) || (m[3] && m[1] !== 'collections')) return null;
      return {name:m[2],type:m[1],tags:m[3] || ''};
    } catch { return null; }
  };
  const location = el => {
    if (el.closest('[data-mobile-menu]')) return 'mobile';
    if (el.closest('[data-desktop-header], [data-nav-desktop]')) return 'desktop';
    if (el.closest('footer, .footer')) return 'footer';
    if (el.closest('[data-sidebar-block]')) return 'sidebar';
    return document.body.classList.contains('index') ? 'homepage' : 'content';
  };
  const paint = () => {
    const output = document.querySelector('[data-pp-tracking-log]');
    if (output) output.textContent = 'Analytics permission: ' + (allowed() ? 'allowed' : 'blocked/unavailable') + ' | Clarity API: ' + (typeof window.clarity === 'function' ? 'available' : 'unavailable') + '\n' + (log.join('\n') || 'No tracked actions yet.');
  };
  const emit = parts => {
    if (!parts.every(slug)) return;
    const name = (preview ? 'pp_test' : 'pp') + '__' + parts.join('__');
    let result = 'blocked by consent';
    try {
      if (window.Shopify?.designMode) result = 'theme editor: skipped';
      else if (allowed()) {
        if (typeof window.clarity === 'function') {
          window.clarity('event', name);
          result = 'dispatched to Clarity (receipt unconfirmed)';
        } else result = 'Clarity unavailable: dropped';
      }
    } catch { result = 'API error: dropped'; }
    if (preview) { log.unshift(name + ': ' + result); log.length = Math.min(log.length,12); window.console.info('[PP tracking]', name, result); paint(); }
  };
  // Capture before InstantClick; this listener never changes navigation.
  document.addEventListener('click', event => {
    if (!event.isTrusted || event.button !== 0) return;
    const a = event.target.closest?.('a[href], summary[data-href]');
    if (!a || a.closest('form') || a.hasAttribute('download')) return;
    if (a.closest('[data-mobile-menu]') && event.target.closest?.('.icon-down-arrow')) return;
    const href = a.getAttribute('href') || a.getAttribute('data-href');
    if (!href || href.startsWith('#')) return;
    const current = path(window.location.href);
    try {
      const productURL = new URL(href,window.location.origin);
      const product = productURL.pathname.match(/^\/(?:collections\/[a-z0-9_-]+\/)?products\/([a-z0-9][a-z0-9_-]{0,99})\/?$/);
      if (product && productURL.origin === window.location.origin && current?.type === 'collections' && !a.closest('header, footer, [data-mobile-menu], [data-desktop-header]')) {
        emit(['product_select',current.name,product[1]]); return;
      }
    } catch { return; }
    const target = path(href);
    if (!target) return;
    const filter = a.closest('[data-pp-filter-value]');
    const group = a.closest('[data-pp-filter-group]');
    if (filter && group && current?.type === 'collections' && current.name === target.name) {
      emit(['filter',filter.hasAttribute('data-active-legacy-filter') ? 'remove' : 'add',group.getAttribute('data-pp-filter-group'),filter.getAttribute('data-pp-filter-value')]);
      return;
    }
    if (a.closest('.tag-filter-list')) return;
    if (current?.tags && target.type === 'collections' && target.name === current.name && !target.tags && !new URL(href,window.location.origin).search) {
      emit(['filter','clear',current.name]); return;
    }
    if (target.tags || new URL(href,window.location.origin).searchParams.has('page')) return;
    emit(['nav',location(a),target.type,target.name]);
  },true);
  const armed = new WeakMap();
  const arm = e => {
    if (!e.isTrusted) return;
    const d = e.target.closest?.('details[data-mobile-menu], details[data-nav-desktop-details]');
    if (d) armed.set(d,Date.now());
  };
  document.addEventListener('pointerover',arm,true);
  document.addEventListener('click',arm,true);
  document.addEventListener('keydown',arm,true);
  document.addEventListener('toggle', e => {
    const el = e.target;
    if (!el.open || Date.now() - (armed.get(el) || 0) > 2000) return;
    if (el.matches('[data-mobile-menu]')) emit(['menu_open','mobile','main']);
    else if (el.matches('[data-nav-desktop-details]')) {
      const name = path(el.querySelector(':scope > summary')?.getAttribute('data-href'))?.name;
      if (slug(name)) emit(['menu_open','desktop',name]);
    }
  },true);
  document.addEventListener('visitorConsentCollected',paint);
  // Mobile legacy submenus use a class/visibility transition rather than details.
  document.addEventListener('click', e => {
    if (!e.isTrusted || e.button !== 0) return;
    const a = e.target.closest?.('[data-mobile-menu] a.parent-link--true, [data-mobile-menu] a.parent-link--false');
    const submenu = a?.parentElement?.querySelector(':scope > ul');
    if (!submenu) return;
    const wasOpen = window.getComputedStyle(submenu).display !== 'none';
    const name = a.getAttribute('data-pp-menu') || a.parentElement.getAttribute('data-mobile-dropdown-rel') || submenu.querySelector('[data-meganav-handle]')?.getAttribute('data-meganav-handle') || path(a.getAttribute('href'))?.name;
    if (!slug(name)) return;
    window.setTimeout(() => {
      if (a.isConnected && !wasOpen && window.getComputedStyle(submenu).display !== 'none') emit(['menu_open','mobile',name]);
    },400);
  },true);
  document.addEventListener('click',() => window.setTimeout(paint,0),true);
  if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],paint);
  }
  // No stored identifiers, cookies, replay queue, form values or query strings.
  paint();
})();
